/**
 * Calm & Relaxed Theme
 * Peaceful ocean-inspired blues for a tranquil workspace
 */

export const calmRelaxedTheme = {
  theme_name: 'Calm & Relaxed',
  theme_description:
    'Clean modern design inspired by ClickUp - light gray with blue accents',
  vibe: 'Clean & Creative',

  // Colors - ClickUp-inspired clean design (no purple)
  primary_color: '#2563EB', // Clean blue for primary actions
  secondary_color: '#718096', // Gray for secondary elements
  accent_color: '#1D4ED8', // Darker blue for accents
  background_color: '#F9FAFB', // Very light gray background
  surface_color: '#FFFFFF', // White for cards/surfaces
  text_color: '#1A202C', // Dark text for readability
  text_secondary: '#718096', // Secondary text
  text_muted: '#A0AEC0', // Muted text
  divider_color: '#E2E8F0', // Light dividers

  // Semantic Status Colors - Clean and vibrant
  success_color: '#10B981', // Emerald green
  error_color: '#EF4444', // Clean red
  warning_color: '#F59E0B', // Amber warning
  info_color: '#3B82F6', // Blue info

  // Typography - Modern and clean
  font_family: "'Inter', 'Helvetica Neue', 'Arial', sans-serif",
  font_size: '14px',
  heading_font_size: '2rem', // Increased from 1.5rem for better readability
  font_weight_normal: '400',
  font_weight_bold: '600',

  // Layout - Clean and minimal
  border_radius: 8,
  spacing_unit: 8,

  // Theme mode
  mode: 'light',

  // Assets
  logo_url: '',
  favicon_url: '',

  // Custom CSS for ClickUp-inspired design
  custom_css: `
    /* Clean card styling */
    .MuiCard-root {
      background-color: #FFFFFF;
      border: 1px solid #E2E8F0;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
      border-radius: 8px;
    }
    
    /* Button styling */
    .MuiButton-root {
      text-transform: none;
      font-weight: 500;
      border-radius: 6px;
    }
    
    .MuiButton-contained {
      box-shadow: none;
    }
    
    .MuiButton-contained:hover {
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
    
    /* Primary button styling */
    .MuiButton-containedPrimary {
      background-color: #6B46C1;
    }
    
    .MuiButton-containedPrimary:hover {
      background-color: #553C9A;
    }
    
    /* Input fields */
    .MuiOutlinedInput-root {
      background-color: #FFFFFF;
      border-radius: 6px;
    }
    
    .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: #6B46C1;
      border-width: 2px;
    }
    
    /* Sidebar styling */
    .MuiDrawer-paper {
      border-right: 1px solid #E2E8F0;
      background-color: #F9FAFB;
    }
    
    /* Navigation items */
    .MuiListItem-root {
      border-radius: 6px;
      margin: 1px 8px;
    }
    
    .MuiListItem-root.Mui-selected {
      background-color: #6B46C1;
      color: #FFFFFF;
    }
    
    .MuiListItem-root.Mui-selected .MuiListItemIcon-root {
      color: #FFFFFF;
    }
    
    /* Avatar styling */
    .MuiAvatar-root {
      background-color: #6B46C1;
      color: #FFFFFF;
      font-weight: 600;
      font-size: 0.875rem;
    }
    
    /* Typography hierarchy */
    .MuiTypography-h1 {
      font-weight: 600;
      color: #1A202C;
    }
    
    .MuiTypography-h2 {
      font-weight: 600;
      color: #1A202C;
    }
    
    .MuiTypography-h3 {
      font-weight: 500;
      color: #1A202C;
    }
    
    /* Subtle borders and dividers */
    .MuiDivider-root {
      background-color: #E2E8F0;
    }
    
    /* Table styling */
    .MuiTable-root {
      background-color: #FFFFFF;
    }
    
    .MuiTableHead-root {
      background-color: #F9FAFB;
    }
    
    .MuiTableCell-root {
      border-bottom: 1px solid #E2E8F0;
    }
    
    /* Tab styling */
    .MuiTab-root.Mui-selected {
      color: #6B46C1;
    }
    
    .MuiTabs-indicator {
      background-color: #6B46C1;
    }
  `,

  // Status
  is_active: false,
  status: 'inactive',
};

export default calmRelaxedTheme;
